import api from '../config/api';
import { Audience } from '../models/audiences/types';

export interface AudienceResource {
  id: string;
  type: string;
  attributes: Audience;
}

export interface AudiencesIndexResponse {
  data: AudienceResource[];
  meta: {
    current_page: number;
    page_size: number;
    total_records: number;
    total_pages: number;
  };
  links?: {
    next?: string;
  };
}

export interface AudiencesIndexParams {
  page?: number;
  page_size?: number;
  q?: string;
}

class AudiencesService {
  fetchAll = (params?: AudiencesIndexParams) => {
    return api.get<AudiencesIndexResponse>('/audiences', { params });
  };
}

export default AudiencesService;
